import { z } from "zod";
import { CONFIRM_PASSWORD, OTP, NEW_PASSWORD } from "./consts";

export const schema = z.object({
  [OTP]: z.string().optional(),
  [NEW_PASSWORD]: z
      .string()
      .min(8, "The minimum length required is 8 characters."),
    [CONFIRM_PASSWORD]: z
      .string()
      .min(8, "The minimum length required is 8 characters."),
});

export type formValues = z.infer<typeof schema>;
